import React from "react";
import PropTypes from "prop-types";

const SkeletonTable = ({ rows = 9, columns = 6 }) => {
  return (
    <div className="relative overflow-x-auto bg-white rounded-2xl shadow-md">
      <table className="w-full text-sm text-left text-[#262424] font-bold border-collapse">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <th key={colIndex} className="px-6 py-4">
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y">
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="border-b border-[#F0F0F0] animate-pulse">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className="px-6 py-4">
                  <div className="h-4 w-full max-w-[120px] bg-gray-200 rounded"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

SkeletonTable.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
};

export default SkeletonTable;
